import { mapGetters } from 'vuex';

export const pollMixin = {
  computed: {
    ...mapGetters([
      'publicKey',
    ]),
  },
  methods: {

    publicLink() {
      let url =
        process.env.VUE_APP_FRONTEND_URI +
        '/pr/' +
        this.poll.id +
        '/' +
        this.publicKey;
      return url;
    },

    polltype(type) {
      switch (type) {
        case 1:
          return this.$t('polls.typePoll');

        case 2:
          return this.$t('polls.typeEvent');

        case 3:
          return this.$t('polls.typeSurvey');

        default:
          return this.$t('general.undefinedPoll');
      }
    },

    iconColor(type) {
      switch (type) {
        case 1:
          return 'text-primary';

        case 2:
          return 'text-event';

        case 3:
          return 'text-survey';
      }
      return 'text-primary';
    },
    icon(type) {
      switch (type) {
        case 1:
          return ['fal', 'calendar-check'];

        case 2:
          return ['fal', 'envelope-open-text'];

        case 3:
          return ['fal', 'ballot-check'];
      }
      return ['fal', 'calendar-check'];
    },
    findImageFromListUsingURL(
      images,
      userImages,
      searchImagePath,
      getIdInResponse = true
    ) {
      let curImage = images.find((image) => image.url == searchImagePath);
      if (curImage) {
        if (getIdInResponse == true) {
          return curImage.id;
        }
        return curImage;
      } else {
        if (userImages) {
          curImage = userImages.find((image) => image.url == searchImagePath);
          if (curImage) {
            if (getIdInResponse == true) {
              return curImage.id;
            }
            return curImage;
          }
        }
      }
      return -1;
    },
    findLogoFromListUsingURL(
      userImages,
      searchImagePath,
      getIdInResponse = true
    ) {
      let curImage = -1;
      if (userImages) {
        curImage = userImages.find((image) => image.url == searchImagePath);
        if (curImage) {
          if (getIdInResponse == true) {
            return curImage.id;
          }
          return curImage;
        }
      }
      return curImage;
    },
  },
};
